<div class="dependents">
  <ul *ngIf="creditCards.length > 0 || amount === 0">
    <li>
      <div class="content">
        <div *ngIf="requisicaoGetAmountRealizada" class="descricao-dependentes">
          <h4>R$ {{ amount.toFixed(2) }}</h4>
          <p *ngIf="showPayments" style="font-size: 15px; color: #c00d1e;">* O valor acima é referente à segunda via. Este valor será debitado do seu cartão de crédito.
            Após a solicitação, você receberá um e-mail com a confirmação do pedido.
            O cartão será entregue na escola em um prazo de 15 dias.
            Enquanto você aguarda o recebimento do cartão, utilize o nome de usuário e senha para comprar nos terminais Meep.</p>
          <p *ngIf="!showPayments" style="font-size: 15px; color: #c00d1e;">* O valor acima é referente à segunda via.
            Após a solicitação, você receberá um e-mail com a confirmação do pedido.
            Procure a cantina para efetivar o pagamento e retirar o cartão.
            Até retirar o cartão, você pode utilizar o nome de usuário e senha para comprar nos terminais Meep.</p>
          <div class="pagamento" *ngIf="showPayments" >
            <h6>Método de Pagamento</h6>
            <app-input-select [children]="creditCards" [validators]="['required']" (isInputValid)="setFormStatus($event, 'creditCard')" [(value)]="creditCard"></app-input-select>
          </div>
          <div class="pagamento" *ngIf="showPayments" >
            <h6>CVV</h6>
            <app-input [inputModel]="creditCardCVV" (isInputValid)="setFormStatus($event, 'creditCardCVV')" [(value)]="securityCode"></app-input>
          </div>

        </div>
      </div>
    </li>
  </ul>

  <button *ngIf="creditCards.length > 0 || amount === 0" class="confirma" (click)="buy()">
    Confirmar
  </button>
  <button *ngIf="creditCards.length === 0 && amount > 0" class="confirma" (click)="registerCreditCard()">
    Cadastrar um cartão de crédito
  </button>


</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/duplicate-pay/duplicate-pay.component.html